import {
  AfterContentInit,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core'
import { TabComponent } from './tab/tab.component'

@Component({
  selector: 'sume-tabbed-form',
  templateUrl: './tabbed-form.component.html',
})
export class TabbedFormComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>

  constructor() {}

  ngAfterContentInit() {
    const tabs = this.tabs.toArray()
    tabs[0].active = true
  }

  selectTab(tab: TabComponent) {
    this.tabs.forEach(tab => (tab.active = false))
    tab.active = true
  }
}
